module.exports = __webpack_public_path__ + "static/media/vkontakte.9ec9d581.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/vkontakte.svg
// module id = 210
// module chunks = 0